export function hasCustomPanelBackground(style = {}) {
    if (!style || typeof style !== "object") return false;

    const normalize = (v) => (typeof v === "string" ? v.trim() : "");
    const bgImage = normalize(style.backgroundImage);
    const bgColor = normalize(style.backgroundColor);
    const bg = normalize(style.background);

    if (bgImage && bgImage !== "none") return true;
    if (bgColor && bgColor !== "transparent") return true;
    if (bg && bg !== "transparent") return true;

    return false;
}

export function buildPanelClassName({ style = {}, extra = "" } = {}) {
    const hasCustom = hasCustomPanelBackground(style);
    return [
        "component-item",
        hasCustom ? "panel-has-bg" : "panel-default-bg",
        extra,
    ]
        .filter(Boolean)
        .join(" ");
}
